import React from "react";
import PropTypes from "prop-types";
import { Popover } from "antd";

import { IconLight } from "../";

const defaultStyles = {
  color: "#143660",
  fontWeight: "bold"
};

const errorStyles = {
  color: "#f5222d",
  fontWeight: "bold"
};

const PanelHeader = ({ heading, errorMessage }) => {
  return (
    <div className={"test-panel-header"}>
      {errorMessage ? (
        <Popover
          title=""
          content={errorMessage}
          trigger={"hover"}
          style={errorStyles}
        >
          <span style={errorStyles}>
            {heading} <IconLight icon={"exclamation-triangle"} />
          </span>
        </Popover>
      ) : (
        <div style={defaultStyles}>{heading}</div>
      )}
    </div>
  );
};

PanelHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  errorMessage: PropTypes.string
};

export default PanelHeader;



// WEBPACK FOOTER //
// ./src/views/components/panel_header/PanelHeader.jsx